<template>
  <el-dialog
    title="任务流转"
    width="700px"
    top="0px"
    :visible.sync="dialogVisible"
    @close="cancelDialog"
    @opened="opened"
    append-to-body
  >
    <el-form label-width="80px" :model="circulation" ref="ruleForm" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item label="任务编号" label-width="90px">
            <span>{{curTask.INSTANCE}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="创建人" label-width="90px">
            <span>{{curTask.CREATEUSERNAME}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item v-if="!approval" label="接收方" label-width="90px" prop="ReceiveUserName">
            <ayb-select-receiver
              :isRadio="true"
              class="selectInput"
              ref="selectedReceiveUser"
              @clear="clearReceiver"
              @getValue="getReceiver"
            ></ayb-select-receiver>
          </el-form-item>
          <el-form-item v-else label="处理人" label-width="90px">{{approval.auditorName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="接收时长" label-width="90px">
            <div class="timeDiv">
              <el-input-number v-model="timeNum" :min="1" :max="1000" class="timeInput"></el-input-number>
              <el-select
                v-model="timeUnit"
                style="width:90px;margin-left:10px"
                placeholder="请选择"
                class="timeSelector"
              >
                <el-option
                  v-for="item in timeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <!-- <selectAllUser @getValue="getNoticePersons" class="selectInput" ref="selectedNoticeUser"></selectAllUser> -->

            <!-- <selectAllUserComponent :isRadio="false"
                                    setWidth="100%"
                                    @getValue="getNoticePersons"
            ref="selectedNoticeUser"></selectAllUserComponent>-->
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="流转原因" label-width="90px" prop="convertReason">
        <el-input
          type="textarea"
          :rows="6"
          placeholder="请输入流转原因"
          v-model="circulation.convertReason"
        ></el-input>
      </el-form-item>
      <el-form-item label label-width="90px">
        <el-row>
          <el-col :span="12">
            <el-radio v-model="continueFocus" :label="false">不在关注</el-radio>
            <el-radio v-model="continueFocus" :label="true">继续关注</el-radio>
          </el-col>
          <el-col :span="12">
            <el-radio v-model="isMonitor" :label="false">不在负责</el-radio>
            <el-radio v-model="isMonitor" :label="true">继续负责</el-radio>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-checkbox :checked="isMonitor">继续负责</el-checkbox> -->
      <el-button @click="dialogVisible=false">取 消</el-button>
      <el-button type="primary" @click="saveDialog('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getToken } from "../../../util/auth";
import {
  canConvertTask,
  convertTask,
  setConfig,
} from "@/api/modules/basicData/task";

import comps from "ayb-form-design/src/helpers/comps";
import tool from "ayb-form-design/src/helpers/form";
import { GetFormData } from "ayb-form-design/src/api/custmerForm.js"; //GetSchemeEntity
import { SaveTableData } from "ayb-form-design/src/api/databaseTable.js";
import { Flow } from "ayb-form-design/src/api/WfEngine.js";
import { GetSchemeData } from "ayb-form-design/src/api/WFScheme.js";
import formTool from "ayb-form-design/src/helpers/form";
import { NewAuditFlow } from "ayb-form-design/src/api/WfEngine.js";
import {
  GetTastInfo,
  GetCurrentNodeIds,
} from "ayb-form-design/src/api/WfMyTask.js";
const cookieUser = getToken();
export default {
  name: "ConvertTask",
  props: {
    noticePersons: [],
    typeInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      ApprovalInfo: {},
      approval: null,
      node: {},
      receiver: {},
      isMonitor: false,
      timeNum: 0,
      timeUnit: 0,
      continueFocus: false,
      convertReason: "",
      noticePersonList: [],
      timeOptions: [
        {
          label: "分钟",
          value: 0,
        },
        {
          label: "小时",
          value: 1,
        },
        {
          label: "天",
          value: 2,
        },
      ],
      circulation: {
        ReceiveUserName: "",
        ReceiveUser: {},
        convertReason: "",
      },
      rules: {
        ReceiveUserName: [
          {
            required: true,
            // message: '请选择接收方',
            validator: (rule, value, callback) => {
              value = this.trim(value);
              if (!value) {
                callback(new Error("请选择接收方"));
                this.time("ruleForm", "ReceiveUserName");
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        convertReason: [
          { max: 200, message: "长度在200个字符以内", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    curTask: function () {
      return this.$store.state.task.curTask;
    },
    receiverId: function () {
      return this.receiverId;
    },
  },
  watch: {
    noticePersons: function (newval, oldval) {
      //这里给通知提醒人赋初始值
    },
    curTask: function (newval, oldval) {
      console.log("curTask", newval);
      this.timeUnit = newval.FIRSTRESPONSEUNIT;
      this.timeNum = newval.FIRSTRESPONSENUM;
    },
  },
  methods: {
    async opened() {
      this.approval = null;
      if (this.typeInfo.FLOWID) {
        let dbTable=[];
        let node = await GetSchemeData(this.typeInfo.FLOWID).then((result) => {
          if (result.code === 200) {
            // dbTable = JSON.parse(result.data.schemeEntity.F_Scheme).dbTable;
            return JSON.parse(result.data.schemeEntity.F_Scheme).node;
          } else {
            this.$message.warning("获取模板数据有问题，请重试！");
          }
        });
        let taskNodeInfo = await GetCurrentNodeIds(this.curTask.ID).then(
          (result) => {
            return result.data;
          }
        );
        if(this.typeInfo.FORMID){
          dbTable = await GetFormData(this.typeInfo.FORMID).then(result => {
            return JSON.parse(result.schemeEntity.F_Scheme).data[0];
          });
        }
        this.node = node;
        let ApprovalInfo = await formTool.getApproval(node, taskNodeInfo[0], {}, 1, 1, dbTable.length > 0 ? {tablename: dbTable[0].name, taskid: this.curTask.ID}:"");
        this.ApprovalInfo = ApprovalInfo;
        if (ApprovalInfo.approval.length > 0) this.approval = ApprovalInfo.approval[0];
      }
    },
    clearReceiver() {
      this.receiver = {};
    },
    getReceiver(selectPersons) {
      let info = selectPersons;
      this.receiver = info;
      if (info) {
        this.circulation.ReceiveUser = info;
        this.circulation.ReceiveUserName = info.Name;
        // this.circulation = Object.assign({}, this.circulation, {
        //   ReceiveUser: selectPersons[0],
        //   ReceiveUserName: selectPersons[0].Name
        // });
      } else {
        // this.circulation = Object.assign({}, this.circulation, {
        //   ReceiveUser: {},
        //   ReceiveUserName: ""
        // });
        this.circulation.ReceiveUser = {};
        this.circulation.ReceiveUserName = "";
      }
    },
    getNoticePersons(selectPersons) {
      this.noticePersonList = selectPersons.map(function (person) {
        return {
          ID: person.UserId,
          NAME: person.Name,
          DEPTID: person.DeptId,
          DEPTNAME: person.DeptName,
        };
      });
    },
    resetDialog() {
      this.dialogVisible = false;
      this.receiver = {};
      this.isMonitor = false;
      this.timeNum = 0;
      this.timeUnit = 0;
      this.continueFocus = false;
      this.circulation.convertReason = "";
      this.noticePersonList = [];
    },
    cancelDialog() {
      this.circulation.convertReason = "";
      this.receiver = {};
      // this.$refs.selectedReceiveUser.reset();
      // this.$refs.selectedNoticeUser.reset();
    },
    saveDialog(formName) {
      this.$refs[formName].validate((valid) => {
        console.log(valid);
        if (valid) {
          console.log("saveDialog", this.receiver);
          if (Object.getOwnPropertyNames(this.receiver).length === 0) {
            this.$message.warning("请选择接收方");
            return;
          }
          let task = Object.assign({}, this.curTask);
          if (!this.approval) {
            if (this.receiver.ContactType === 4) {
              if (
                !task.EXCUTEUSERID &&
                task.SERVERCENTERID === this.receiver.Key
              ) {
                this.$message.warning("不能流转给当前处理服务台");
                return;
              }
            } else if (task.EXCUTEUSERID === this.receiver.Key) {
              this.$message.warning("不能流转给当前处理人");
              return;
            }
          }
          let wanderInfo = {
            // ID = Utils.Code.GetShortGuid(),
            OPERATORID: cookieUser.userId,
            OPERATORNAME: cookieUser.realName,
            OPERATORDEPTID: cookieUser.departmentId,
            OPERATORDEPTNAME: cookieUser.departmentName,
            TASKREASON: this.circulation.convertReason,
            TASKID: task.ID,
            TASKNAME: task.TASKNAME,
          };
          if (task.EXCUTEUSERID) {
            wanderInfo.TASKSENDER = task.EXCUTEUSERID;
            wanderInfo.TASKSENDERNAME = task.EXCUTEUSERNAME;
            wanderInfo.TASKSENDERDEPT = task.EXCUTEDEPTID;
            wanderInfo.TASKSENDERDEPTNAME = task.EXCUTEDEPTNAME;
            wanderInfo.TASKSENDRCOMPANYID = task.EXCUTECOMPANYID;
            wanderInfo.TASKSENDERCOMPANYNAME = task.EXCUTECOMPANYNAME;
          } else {
            wanderInfo.TASKSENDER = task.SERVERCENTERID;
            wanderInfo.TASKSENDERNAME = task.SERVERCENTERNAME;
          }
          if (this.approval) {
            wanderInfo.TASKRECIVER = this.approval.auditorId;
            wanderInfo.TASKRECIVERNAME = this.approval.auditorName;
            wanderInfo.TASKRECIVERDEPT = "";
            wanderInfo.TASKRECIVERDEPTNAME = "";
            switch (this.ApprovalInfo.approvalType.type) {
              case "user-select":
                wanderInfo.ISUSER = true; // isUser;
                break;
              case "server-center-select":
                wanderInfo.ISUSER = false;
                break;
              case "receiver-select":
                if (this.approval.auditorId.length > 8) {
                  //服务台
                  wanderInfo.ISUSER = false;
                } else {
                  wanderInfo.ISUSER = true; // isUser;
                }
                break;
              case "post-select":
                this.$message.error("目前不支持岗位审批功能");
                break;
              default:
                break;
            }
          } else {
            if (this.receiver.ContactType === 4) {
              //服务台
              wanderInfo.ISUSER = false;
              wanderInfo.TASKRECIVER = this.receiver.Key;
              wanderInfo.TASKRECIVERNAME = this.receiver.Name;
              wanderInfo.TASKRECIVERDEPT = "";
              wanderInfo.TASKRECIVERDEPTNAME = "";
            } else {
              console.log(this.receiver);
              wanderInfo.ISUSER = true; // isUser;
              wanderInfo.TASKRECIVER = this.receiver.Key;
              wanderInfo.TASKRECIVERNAME = this.receiver.Name;
              wanderInfo.TASKRECIVERDEPT = this.receiver.ParentKey;
              wanderInfo.TASKRECIVERDEPTNAME = this.receiver.ParentName;
            }
          }
          wanderInfo.isMonitor = this.isMonitor;
          wanderInfo.ContinueFocus = this.continueFocus;
          wanderInfo.TimeUnit = this.timeUnit;
          wanderInfo.TimeNum = this.timeNum;
          convertTask(wanderInfo, this.noticePersonList).then((resultMsg) => {
            if (resultMsg.ResultCode) {
              if (this.typeInfo.FLOWID) {
                NewAuditFlow(
                  "",
                  this.curTask.ID,
                  1,
                  this.circulation.convertReason,
                  JSON.stringify(this.ApprovalInfo.approval[0]),
                  JSON.stringify(this.ApprovalInfo.node), //JSON.stringify(currentNode),
                  JSON.stringify({}),
                  this.ApprovalInfo.isFinished
                ).then((res) => {
                  if (res.status !== 1) {
                    this.$message.error("不接收任务失败");
                  }
                });
              }
              this.$emit("convertTaskResult");
              this.$message.success("流转成功");
              this.resetDialog();
            } else {
              this.$message.error(resultMsg.MsgInfo);
              this.resetDialog();
            }
          });
        } else {
          console.log("error submit!!");
          // this.$message.success("未选择接收人");
        }
      });
    },
  },
  created() {},
  components: {},
};
</script>

<style scoped>
.el-form {
  text-align: left;
}
.selectInput {
  display: inline-block;
}
.timeDiv {
  display: flex;
}
</style>
